import { createContext, useContext } from 'react';

// MainTabs keeps visited tabs mounted and hides inactive ones with opacity
// (see hiddenTabScreen in navigation/index.tsx), so React Navigation's
// useIsFocused() stays true for every tab. Components that animate or poll
// continuously read this instead to pause while their tab is hidden.
// Defaults to true for screens rendered outside MainTabs.
export const TabActiveContext = createContext(true);

export const useIsTabActive = () => useContext(TabActiveContext);
